import { useQuery } from "@tanstack/react-query";
import { getLatestTemplates } from "../api/templates.js";
import type { TemplateRunSummary } from "../api/product-types.js";

export function useLatestTemplates(websiteId: string | undefined) {
  return useQuery<TemplateRunSummary | null>({
    queryKey: ["templates", websiteId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      return getLatestTemplates(websiteId);
    },
    enabled: websiteId != null,
  });
}
